import colorConfig from '@/config/color.config'
import Vue from 'vue'

// 设置全局颜色
Vue.prototype.$GColor = colorConfig


// 设置全局css颜色
for (const [key, value] of Object.entries(colorConfig)) {
  document.documentElement.style.setProperty(
   `--${key}`,
    value
  )
}
